export default __webpack_public_path__ + "static/media/Path 106.f7646af5.svg";